import "./Skeleton.scss";

import React from "react";

/**
 * Skeleton genérico (reutilizável)
 *
 * Props:
 * - width/height: número (px) ou string (ex: "100%")
 * - variant: "rect" | "text" | "circle"
 * - count: renderiza N skeletons
 * - className/style: custom
 */
export default function Skeleton({
  width = "100%",
  height = 12,
  variant = "rect",
  count = 1,
  className = "",
  style = {},
}) {
  const w = typeof width === "number" ? `${width}px` : width;
  const h = typeof height === "number" ? `${height}px` : height;

  return (
    <>
      {Array.from({ length: Math.max(1, count) }).map((_, idx) => (
        <span
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          className={`he-skeleton he-skeleton--${variant} ${className}`}
          style={{ width: w, height: h, ...style }}
          aria-hidden="true"
        />
      ))}
    </>
  );
}
